import React from 'react';

import { useSearchParams } from '@/hooks/useSearchParams';

export const useDirectoryState = () => {
    const searchParams = useSearchParams();

    const [state, setState] = React.useState('default');

    React.useEffect(() => {
        setState(!searchParams.has('term') ? 'default' : 'results');
    }, [searchParams]);

    return state;
};
